<template>
  <v-tabs
    color="primary accent-4"
  >
    <v-tab v-if="$store.state.auth.checkAccess({key: 'settings_general', value: true})">General</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'settings_mail', value: true})">Mail</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'paysystem_control', value: true})">Paysystem</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'paysystem_control', value: true})">Paymethods</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'game', value: true})">GameSystems</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'withdraw_limits', value: true})">Withdraw Limits</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'manual_transaction_limits', value: true})">Manual Transaction Limits</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'payout_limits', value: true})">Payment Handler Limits</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'level_formulae_control', value: true})">Level Formulae</v-tab>
    <v-tab v-if="$store.state.auth.checkAccess({key: 'settings_entity', value: true})">Entities</v-tab>

    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'settings_general', value: true})">
      <general />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'settings_mail', value: true})">
      <mail />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'paysystem_control', value: true})">
      <paysystem />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'paysystem_control', value: true})">
      <paymethods />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'game', value: true})">
      <game-system />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'withdraw_limits', value: true})">
      <withdraw-limits />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'manual_transaction_limits', value: true})">
      <manual-transaction-container />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'payout_limits', value: true})">
      <payout-limits-container />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'level_formulae_control', value: true})">
      <level-formulae-container />
    </v-tab-item>
    <v-tab-item v-if="$store.state.auth.checkAccess({key: 'settings_entity', value: true})" >
      <entity-options />
    </v-tab-item>
  </v-tabs>
</template>

<style>

  .settings-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .settings-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

</style>

<script>
  export default {

    components: {
      General: () => import('@/components/settings/General'),
      Mail: () => import('@/components/settings/Mail'),
      Paymethods: () => import('@/components/settings/Paymethods'),
      Paysystem: () => import('@/components/settings/Paysystem'),
      GameSystem: () => import('@/components/settings/GameSystem'),
      WithdrawLimits: () => import('@/components/settings/WithdrawLimits'),
      ManualTransactionContainer: () => import('@/modules/manual-transaction-limits').then(module => module.ManualTransactionLimitsContainer),
      PayoutLimitsContainer: () => import('@/modules/payout-limits').then(module => module.PayoutLimitsContainer),
      LevelFormulaeContainer: () => import('@/modules/level-formulae').then(module => module.LevelFormulaeContainer),
      EntityOptions: () => import('@/components/settings/EntityOptions.vue'),

    },

    data: () => ({}),

    mounted () {
    },

    methods: {},

  }
</script>


